import { Box, Typography } from "@mui/material";
import { useMaintenanceMode } from "@/hooks";
import { useCompanyConfigContext } from "@/context/CompanyConfigContext";
import { AuthLayout } from "@/components/authLayout";
import { DEFAULT_COMPANY_CONFIG } from "@/const";

const DEFAULT_MAINTENANCE_MESSAGE =
  "This site is currently under maintenance. Please check back later.";

export const AppStatus = ({ children }: { children: React.ReactNode }) => {
  const [globalMaintenance, loading, error] = useMaintenanceMode();
  const { companyConfig, settings } = useCompanyConfigContext();

  const allDown = globalMaintenance?.value;
  const maintenanceMode = allDown || companyConfig?.maintenance;

  if (error) {
    throw error;
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  if (maintenanceMode) {
    const message =
      (companyConfig?.maintenance && companyConfig.message) ||
      (allDown && globalMaintenance?.message) ||
      companyConfig?.message ||
      globalMaintenance?.message ||
      DEFAULT_MAINTENANCE_MESSAGE;

    const rewardsName =
      settings.rewardsName || DEFAULT_COMPANY_CONFIG.REWARDS_NAME;

    return (
      <AuthLayout>
        <Box style={{ maxWidth: 480, overflowY: "auto" }}>
          <Box my={1} width="100%" borderTop={1} borderColor="grey.300" />
          <div style={{ fontSize: 18, marginBottom: 8, minHeight: 10 }}>
            {`Welcome to ${rewardsName}!`}
          </div>
          <Box my={1} width="100%" borderBottom={1} borderColor="grey.300" />
          <Typography style={{ whiteSpace: "pre-wrap" }}>{message}</Typography>
        </Box>
      </AuthLayout>
    );
  }

  return children;
};
